import pointCut from "toggle:/point-cuts:/experimental react components";
import * as joinPoint from "/components/ProductListingPage/ProductListingPage.js";
const variants = import.meta.webpackContext("/components/ProductListingPage", { recursive: true, regExp: /\.\/__variants__\/plp\-filtering\-experience\/v2\/ProductListingPage\.js/ });
export default pointCut({ joinPoint, variants });